module.exports = __webpack_public_path__ + "static/menu_album-d07cc450ca31a474ffea4e7d5d6c7914.png";